import { CALL_API } from '../../util/RBRestMiddleware'
import Config from '../../Config'

export const APP_CONTENT_LOADING = 'APP_CONTENT_LOADING'
export const APP_CONTENT_SUCCESS = 'APP_CONTENT_SUCCESS'
export const APP_CONTENT_FAILED = 'APP_CONTENT_FAILED'

export const fetchAppContent = (lang) => {
  const wl = Config.wlKey

  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/content/all?wlKey=${wl}`,
        prefix: 'APP_CONTENT'
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/appContentActions.js